import { IconList16 } from '@cian/ui-kit';
import * as React from 'react';

import { trackShowAllClick } from './tracking';
import { ChatbotButton } from '../../components/ChatbotButton';

export const ShowAllButtonContainer: React.FC = () => {
  const onClick = React.useCallback(() => {
    trackShowAllClick();
    window.open(`/recommendations/`, '_blank');
  }, []);

  return (
    <ChatbotButton theme="fill_white_primary" beforeIcon={<IconList16 color="primary_100" />} onClick={onClick}>
      Посмотреть все
    </ChatbotButton>
  );
};
